import { Component, Input, OnChanges } from "@angular/core";
import { GroupFS } from "../pojo/fund-strategy-export-classes";
import { FsChartOptionsService } from "./fs-charts-service/fs-chart-options.service";
import { FsChartsData, FsChartsOptions } from "./pojo/fs-charts-classes";
import { FsChartsCalcService } from "./fs-charts-service/fs-charts-calc.service";
import { BaseBarChartComponent } from "../../../charts/base-bar-chart/base-bar-chart.component";
import { BasePieChartComponent } from "../../../charts/base-pie-chart/base-pie-chart.component";

@Component({
  selector: 'app-fund-strategy-charts',
  templateUrl: './fund-strategy-charts.component.html',
  styleUrls: ['./fund-strategy-charts.component.scss'],
  standalone: true,
  imports: [
    BaseBarChartComponent,
    BasePieChartComponent,
  ],
})

export class FundStrategyChartsComponent implements OnChanges {
  @Input({ required: true }) fsGroups: GroupFS[] = [];
  @Input({ required: true }) isModelBlocked = false;

  data: FsChartsData;
  options: FsChartsOptions;

  ngOnChanges(): void {
    if (this.fsGroups.length) {
      this.prepareData();
    }
  }

  prepareData(): void {
    this.data = FsChartsCalcService.calculate(this.fsGroups);
    this.prepareOptions();
  }

  prepareOptions(): void {
    this.options = FsChartOptionsService.prepareOptions(this.data);
  }
}
